import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <>
      {/* #NAVBAR */}
      <nav className="navbar">
        <ul className="navbar-list">
          <li className="navbar-item">
            <NavLink
              to={"/"}
              end
              className={({ isActive }) =>
                isActive ? "navbar-link active" : "navbar-link"
              }
            >
              About
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink
              to={"/resume"}
              className={({ isActive }) =>
                isActive ? "navbar-link active" : "navbar-link"
              }
            >
              Resume
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink
              to={"/portfolio"}
              className={({ isActive }) =>
                isActive ? "navbar-link active" : "navbar-link"
              }
            >
              Portfolio
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink
              to={"/blog"}
              className={({ isActive }) =>
                isActive ? "navbar-link active" : "navbar-link"
              }
            >
              Blog
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink
              to={"/contact"}
              className={({ isActive }) =>
                isActive ? "navbar-link active" : "navbar-link"
              }
            >
              Contact
            </NavLink>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
